module.exports = __webpack_public_path__ + "img/fire-blue.c8d7150b.svg";